import React, { useState } from "react";
import { Input } from "reactstrap";

const SortableTableHeader = ({ columns, onSort, showHideZero = false, hideZeros = false, onToggleHideZero = () => { }, hideZeroText = "Hide Zero Subs" }) => {
    const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

    const handleSort = (key) => {
        setSortConfig((prev) => {
            let newConfig;

            if (prev.key !== key) {
                newConfig = { key, direction: "asc" };
            } else if (prev.direction === "asc") {
                newConfig = { key, direction: "desc" };
            } else if (prev.direction === "desc") {
                newConfig = { key: null, direction: null }; // reset
            } else {
                newConfig = { key, direction: "asc" };
            }

            onSort(newConfig);
            return newConfig;
        });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key || !sortConfig.direction)
            return <i className="fas fa-sort text-muted ms-1"></i>;
        return sortConfig.direction === "asc" ? (
            <i className="fas fa-sort-up ms-1"></i>
        ) : (
            <i className="fas fa-sort-down ms-1"></i>
        );
    };

    return (
        <thead className="table-light" style={{
            position: "sticky",
            top: 0,
            zIndex: 5,
            background: "#fff",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)"
        }}>
            <tr>
                {columns.map((col, idx) => (
                    <th
                        key={idx}
                        onClick={col.sortKey ? () => handleSort(col.sortKey) : undefined}
                        style={col.sortKey ? { cursor: "pointer" } : {}}
                    >
                        {col.label}
                        {col.sortKey && getSortIcon(col.sortKey)}
                        {showHideZero && idx === 0 && (
                            <>
                                <Input
                                    type="checkbox"
                                    checked={hideZeros}
                                    onClick={onToggleHideZero}
                                    className="ms-2 me-1"
                                />
                                <small className="text-muted" style={{ cursor: "pointer" }} onClick={onToggleHideZero}>{hideZeroText}</small>
                            </>
                        )}
                    </th>
                ))}
            </tr>
        </thead>
    );
};

export default SortableTableHeader;